import { useAppSelector } from 'store/index';

export const usePublicMenu = () => {
    return useAppSelector(
        ({ publicMenu: { dishlist } }) => dishlist?.categories
    );
};
